import TabBar from '../../component/tab-bar/tab-bar';
import React, { useState } from 'react';
import SearchUsers from '../../component/ui/search-users/search-users';
import { UserType } from '../../api/types/user/user-type';
import { AdvanceSearch } from './advance-search/advance-search';
import { UserSummaryType } from '../../api/types/user/user-summary.type';

const tabs = ['משתמשים'];

interface UsersPageHeaderProps {
  role?: UserType;
}

const UsersPageHeader: React.FC<UsersPageHeaderProps> = ({ role }) => {
  const getHeaderConfig = (role?: UserType) => {
    if (!role) {
      return {
        title: 'משתמשי המערכת',
        subtitle: 'כל המשתמשים',
        backgroundColor: '#f5f5f5',
        borderColor: '#666',
        textColor: '#666',
      };
    }

    switch (role) {
      case UserType.STUDENT:
        return {
          title: 'סטודנטים',
          subtitle: 'רשימת סטודנטים',
          backgroundColor: '#f0f7ff',
          borderColor: '#0066cc',
          textColor: '#0066cc',
        };
      case UserType.LECTURER:
        return {
          title: 'מרצים',
          subtitle: 'רשימת מרצים',
          backgroundColor: '#f0fff4',
          borderColor: '#00994d',
          textColor: '#00994d',
        };
      case UserType.ADMINISTRATION:
        return {
          title: 'מנהלה',
          subtitle: 'רשימת צוות מנהלה',
          backgroundColor: '#f8f0ff',
          borderColor: '#6600cc',
          textColor: '#6600cc',
        };
      default:
        return {
          title: 'משתמשי המערכת',
          subtitle: 'כל המשתמשים',
          backgroundColor: '#f5f5f5',
          borderColor: '#666',
          textColor: '#666',
        };
    }
  };

  const config = getHeaderConfig(role);

  return (
    <div
      style={{
        backgroundColor: config.backgroundColor,
        borderLeft: `4px solid ${config.borderColor}`,
        padding: '20px',
        marginBottom: '16px',
        borderRadius: '8px',
        direction: 'rtl',
      }}
    >
      <h1
        style={{
          margin: 0,
          fontSize: '2rem',
          color: config.textColor,
          fontWeight: 'bold',
        }}
      >
        {config.title}
      </h1>
      <p
        style={{
          margin: '8px 0 0 0',
          color: '#666',
          fontSize: '1.1rem',
          lineHeight: '1.5',
        }}
      >
        {config.subtitle}
      </p>
    </div>
  );
};

export const UsersPage: React.FC<{ role?: UserType }> = ({ role }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedUser, setSelectedUser] = useState<
    UserSummaryType | undefined
  >();
  const [newUserToAdd, setNewUserToAdd] = useState<
    UserSummaryType | undefined
  >();

  const handleUserCreated = (user: UserSummaryType) => {
    setNewUserToAdd(user);
  };

  const pages = [
    <SearchUsers
      title={'משתמשים123'}
      role={role}
      selectedUserToDisplay={selectedUser}
      onSelectedUserDialogHide={() => setSelectedUser(undefined)}
      onUserCreated={handleUserCreated}
    />,
  ];

  return (
    <div style={{ marginLeft: '16px' }}>
      <div style={{ marginTop: '20px' }}>
        <UsersPageHeader role={role} />
      </div>

      <TabBar
        tabs={tabs}
        onClick={(index) => {
          setSelectedIndex(index);
        }}
      ></TabBar>

      <div style={{ marginTop: '16px' }}>{pages[selectedIndex]}</div>

      <AdvanceSearch
        userRole={role}
        setSelectedUser={setSelectedUser}
        newUserToAdd={newUserToAdd}
      />
    </div>
  );
};
